import Payment from "../components//PaymentMubeenAccount";

const DigitalAssetStoragePage = () => {
  const handleWhatsAppClick = (packageName) => {
    const message = encodeURIComponent(
      `Hi! I'm interested in the ${packageName} storage plan. Could you please provide more details?`,
    );
    const phoneNumber = "+923124998010";
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  const packages = [
    {
      name: "Start",
      price: "$140",
      period: "/month",
      features: [
        "Secure Cloud Storage",
        "100GB Encrypted Storage",
        "Basic Access Controls",
        "Daily Backups",
        "99.9% Uptime",
        "Standard Support",
      ],
      popular: false,
      color: "primary",
    },
    {
      name: "Standard",
      price: "$230",
      period: "/month",
      features: [
        "Secure Cloud Storage",
        "500GB Encrypted Storage",
        "Advanced Access Controls",
        "Hourly Backups",
        "99.99% Uptime",
        "Priority Support",
        "Multi-Device Sync",
      ],
      popular: false,
      color: "primary",
    },
    {
      name: "Pro",
      price: "$330",
      period: "/month",
      features: [
        "Enterprise Cloud Storage",
        "2TB Encrypted Storage",
        "Custom Access Policies",
        "Real-Time Backups",
        "99.99% Uptime",
        "Dedicated Account Manager",
        "Advanced Encryption",
        "API Access & Integration",
      ],
      popular: false,
      color: "warning",
    },
    {
      name: "One Time",
      price: "$350",
      period: "one-time",
      features: [
        "Enterprise Cloud Storage",
        "250GB Encrypted Storage",
        "Custom Access Policies",
        "Real-Time Backups",
        "99.99% Uptime",
        "Dedicated Account Manager",
        "Advanced Encryption",
        "API Access & Integration",
      ],
      popular: true,
      color: "success",
    },
  ];

  return (
    <div
      style={{ fontFamily: "Arial, sans-serif", backgroundColor: "#f8f9fa" }}
    >
      {/* Header */}
      <header
        style={{
          backgroundColor: "#2c3e50",
          color: "white",
          padding: "60px 0",
        }}
      >
        <div className="container text-center">
          <h1
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: "20px",
            }}
          >
            Digital Asset Storage
          </h1>
          <p style={{ fontSize: "1.2rem", opacity: 0.9 }}>
            Secure, Scalable & Encrypted Storage Solutions for Your Business
          </p>
        </div>
      </header>

      {/* Pricing Section */}
      <section style={{ padding: "80px 0" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#2c3e50",
                  marginBottom: "20px",
                }}
              >
                Choose Your Storage Plan
              </h2>
              <p
                style={{
                  fontSize: "1.1rem",
                  color: "#6c757d",
                  maxWidth: "600px",
                  margin: "0 auto",
                }}
              >
                Flexible and secure storage options to fit your digital needs
              </p>
            </div>
          </div>

          <div className="row justify-content-center">
            {packages.map((pkg, index) => (
              <div key={index} className="col-lg-4 col-md-6 mb-4">
                <div
                  className={`card h-100 ${
                    pkg.popular ? "border-success" : ""
                  }`}
                  style={{
                    boxShadow: pkg.popular
                      ? "0 10px 30px rgba(0,0,0,0.2)"
                      : "0 5px 15px rgba(0,0,0,0.1)",
                    border: pkg.popular
                      ? "3px solid #28a745"
                      : "1px solid #dee2e6",
                    transform: pkg.popular ? "scale(1.05)" : "scale(1)",
                    transition: "all 0.3s ease",
                  }}
                >
                  {pkg.popular && (
                    <div
                      style={{
                        backgroundColor: "#28a745",
                        color: "white",
                        textAlign: "center",
                        padding: "10px",
                        fontWeight: "bold",
                        fontSize: "0.9rem",
                      }}
                    >
                      MOST POPULAR
                    </div>
                  )}

                  <div className="card-body d-flex flex-column">
                    <div className="text-center mb-4">
                      <h3
                        style={{
                          fontSize: "1.8rem",
                          fontWeight: "bold",
                          color: "#2c3e50",
                        }}
                      >
                        {pkg.name}
                      </h3>
                      <div style={{ margin: "20px 0" }}>
                        <span
                          style={{
                            fontSize: "3rem",
                            fontWeight: "bold",
                            color: "#e74c3c",
                          }}
                        >
                          {pkg.price}
                        </span>
                        <span style={{ fontSize: "1.1rem", color: "#6c757d" }}>
                          {pkg.period}
                        </span>
                      </div>
                    </div>

                    <ul className="list-unstyled flex-grow-1">
                      {pkg.features.map((feature, idx) => (
                        <li
                          key={idx}
                          style={{
                            padding: "8px 0",
                            borderBottom: "1px solid #f8f9fa",
                          }}
                        >
                          <span
                            style={{ color: "#28a745", marginRight: "10px" }}
                          >
                            ✓
                          </span>
                          {feature}
                        </li>
                      ))}
                    </ul>

                    <button
                      className={`btn btn-${pkg.color} btn-lg w-100 mt-3`}
                      onClick={() => handleWhatsAppClick(pkg.name)}
                      style={{
                        fontWeight: "bold",
                        padding: "12px",
                        fontSize: "1.1rem",
                        transition: "all 0.3s ease",
                      }}
                    >
                      Get Started via WhatsApp
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={{ backgroundColor: "white", padding: "80px 0" }}>
        <div className="container text-center">
          <h2
            style={{
              fontSize: "2.5rem",
              fontWeight: "bold",
              color: "#2c3e50",
              marginBottom: "20px",
            }}
          >
            Why Choose Our Storage?
          </h2>
          <div className="row">
            <div className="col-md-4 mb-4">
              <div
                style={{
                  backgroundColor: "#3498db",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  color: "white",
                  fontSize: "2rem",
                }}
              >
                🔐
              </div>
              <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>
                Secure Encryption
              </h4>
              <p style={{ color: "#6c757d" }}>
                Your assets are protected with enterprise-grade encryption at
                rest and in transit.
              </p>
            </div>

            <div className="col-md-4 mb-4">
              <div
                style={{
                  backgroundColor: "#2ecc71",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  color: "white",
                  fontSize: "2rem",
                }}
              >
                ⚡
              </div>
              <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>
                High Availability
              </h4>
              <p style={{ color: "#6c757d" }}>
                99.99% uptime ensures your assets are always available whenever
                you need them.
              </p>
            </div>

            <div className="col-md-4 mb-4">
              <div
                style={{
                  backgroundColor: "#f39c12",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  color: "white",
                  fontSize: "2rem",
                }}
              >
                🌍
              </div>
              <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>
                Global Access
              </h4>
              <p style={{ color: "#6c757d" }}>
                Access your assets securely from anywhere in the world with
                multi-device sync.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Payment Information Section */}
      <Payment />
      {/* <section
        style={{
          backgroundColor: "#34495e",
          color: "white",
          padding: "60px 0",
        }}
      >
        <div className="container text-center">
          <h2
            style={{
              fontSize: "2.2rem",
              fontWeight: "bold",
              marginBottom: "20px",
            }}
          >
            Payment Information
          </h2>
          <p style={{ fontSize: "1.1rem", opacity: 0.9, marginBottom: "30px" }}>
            Secure and convenient payment options for your storage plan
          </p>
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div
                style={{
                  backgroundColor: "rgba(255,255,255,0.1)",
                  padding: "30px",
                  borderRadius: "10px",
                  border: "1px solid rgba(255,255,255,0.2)",
                }}
              >
                <h4 style={{ marginBottom: "20px", color: "#3498db" }}>
                  Bank Transfer Details
                </h4>
                <div style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
                  <div style={{ marginBottom: "10px" }}>
                    <strong>Account Number:</strong> PK24ABPA0010130006010017
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    <strong>Account Holder:</strong> Uzair Ahmad Babar
                  </div>
                  <div>
                    <strong>Bank:</strong> Allied Bank
                  </div>
                  <div
                    style={{
                      backgroundColor: "rgba(52, 152, 219, 0.2)",
                      padding: "15px",
                      borderRadius: "5px",
                      fontSize: "0.95rem",
                    }}
                  >
                    <strong>Note:</strong> Please contact us via WhatsApp after
                    payment with your transaction reference for immediate
                    account activation.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Footer */}
      <footer
        style={{
          backgroundColor: "#2c3e50",
          color: "white",
          padding: "40px 0",
          textAlign: "center",
        }}
      >
        <div className="container">
          <h3 style={{ marginBottom: "20px" }}>Digital Asset Storage</h3>
          <p style={{ opacity: 0.8, marginBottom: "20px" }}>
            Secure & Scalable Cloud Storage | Available 24/7 for Support
          </p>
          <button
            className="btn btn-success btn-lg"
            onClick={() => handleWhatsAppClick("General Inquiry")}
            style={{
              fontWeight: "bold",
              padding: "12px 30px",
              fontSize: "1.1rem",
            }}
          >
            💬 Contact Us on WhatsApp
          </button>
          <div style={{ marginTop: "30px", opacity: 0.6 }}>
            <p>&copy; 2025 Digital Asset Storage. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Bootstrap CSS */}
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
        rel="stylesheet"
      />
    </div>
  );
};

export default DigitalAssetStoragePage;
